import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import translationEn from './locals/en/translation.json';
import translationFr from './locals/fr/translation.json';
import { componentTranslations, setYupLocale } from 'vopay';
import { registerSharedTranslations } from 'shared';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: false,
    returnNull: false,
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        originalTranslations: JSON.parse(JSON.stringify(translationEn)),
        translations: JSON.parse(JSON.stringify(translationEn)),
        components: componentTranslations.en,
      },
      fr: {
        originalTranslations: JSON.parse(JSON.stringify(translationFr)),
        translations: JSON.parse(JSON.stringify(translationFr)),
        components: JSON.parse(JSON.stringify(componentTranslations.fr)),
      },
      'fr-CA': {
        originalTranslations: JSON.parse(JSON.stringify(translationFr)),
        translations: JSON.parse(JSON.stringify(translationFr)),
        components: JSON.parse(JSON.stringify(componentTranslations.fr)),
      },
    },
    detection: {
      order: ['localStorage', 'sessionStorage'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    ns: ['translations'],
    defaultNS: 'translations',
  });

// ID-12910: `packages/shared` owns its strings but deliberately owns no i18next instance — it
// resolves keys against whichever host renders it. Registering the bundle here puts shared's
// namespace on this app's instance, so a shared component and the host share one language state.
registerSharedTranslations(i18n);

// Module scope on purpose: Yup captures locale messages at schema-construction time, so
// this must run before any component module builds a schema (see setYupLocale's docs).
setYupLocale(i18n);

export default i18n;
